import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare var Fingerprint2: any;

@Injectable({
  providedIn: 'root'
})
export class MainService {

  private browserLang: string;
  private lang: string;
  private source: string;

  constructor(private translate: TranslateService) { }

  // Get browser language
  public getLanguage() {
    this.browserLang = navigator.language;
    if (this.browserLang !== null) {
      switch (this.browserLang) {
        case 'fr':
          return 'fr';
        case 'fr-FR':
          return 'fr';
        case 'en':
          return 'en';
        case 'en-EN':
          return 'en';
        case 'es-ES':
          return 'es';
        case 'es':
         return 'es';
        default:
          return 'en';
      }
    }
  }

  // Get source language
  public getSource() {
    if (window.localStorage.getItem('source')) {
      return window.localStorage.getItem('source');
    } else {
      return 'm-shop';
    }
  }

  // Manual switch browser language
  public switchLanguage(language: string) {
    this.translate.use(language);
  }

  // Get browser
  public getFingerprint() {
    new Fingerprint2().get(
      (result, components) => {
        // console.log(components);
      }
    );
  }
}
